import { Modifier } from '../modifier';
import { ModifierPriority, ModifierTags, StatusEffect } from '../modifier.type';
import { StatusEffectRegistry } from '../status-effects';

export class Impervious extends Modifier {
  static readonly baseTitle = 'Impervious';
  static readonly baseText = 'Resist an incoming Bane, then fade.';
  static readonly baseIcon = 'blessed';
  static readonly baseTags = [ModifierTags.Boon];
  static readonly basePriority = ModifierPriority.Middle;

  // Instance properties that can change
  title = Impervious.baseTitle;
  text = Impervious.baseText;
  icon = Impervious.baseIcon;
  tags: Array<ModifierTags> = [...Impervious.baseTags];
  priority = Impervious.basePriority;

  modifierAdd(type: StatusEffect, stacks: number) {
    const modifier = StatusEffectRegistry.create(type, this.owner, 0);
    if (modifier.tags.includes(ModifierTags.Bane)) {
      this.removeStacks(1);
      return 0;
    }
    return stacks;
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.Impervious, Impervious);
